import { render, staticRenderFns } from "./LocationsAlphabetically.vue?vue&type=template&id=c099069a"
import script from "./LocationsAlphabetically.vue?vue&type=script&lang=js"
export * from "./LocationsAlphabetically.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports